module.exports = __webpack_public_path__ + "img/20191230155943360截图20191230104814598.0bac4729.jpg";